import console from '@/services/ConsoleService'
import { MODAL_STATES, HOME, PATHS } from 'src/config/app'
import Env from 'src/config/env'

export const setVersion = (state, data) => {
  state.version.build = data.build
  state.version.date = data.date
}

export const setReducedMotion = (state, value) => { 
  state.reduced_motion = value
  state.motion_clamp = state.reduced_motion ? 0 : 1 
}

// **************************************************
//
// LOADING
//
// **************************************************
export const setLoadProgress = (state, progress) => {
  state.loading.progress = Math.min(progress, 1)
}
export const setLoadState = (state, value) => {  
  state.loading.state = value 
}
export const setLoadComplete = (state) => {
  state.loading.progress = 1
  state.loading.completed = true
}

// **************************************************
//
// ROUTE
//
// **************************************************
export const setRoute = (state, params) => {
  state.route.prev.parent = state.route.curr.parent
  state.route.prev.child = state.route.curr.child

  state.route.curr.parent = params.parent
  state.route.curr.child = params.child
}

export const setRouteAfterLoad = (state, value) => {
  console.log('setafterload', value)
  if(Env.ie){
    state.route.afterLoad = PATHS.UNSUPPORTED
  } else {
    state.route.afterLoad = value
  }
}

export const setLoadingCopy = (state, value) => { 
  state.loadingCopy = value
}


export const setModalState = (state, value) => {
  state.modal_state = value

  if(!Env.mobile){
    state.home.mode = (value === MODAL_STATES.MENU) ? HOME.MODES.MENU_EXPLORE : HOME.MODES.DEFAULT
  }
}

export const setVideoModalSrc = (state, value) => {
  state.video_overlay.videoId = value
}
 
export const setScrollLock = (state, value) => {
  state.home.scrollLock = value
}

export const setHomeSectionByIndex = (state, value) => {
  if( !state.home.scrollLock ){
    state.home.prev_section = state.home.current_section
    state.home.section_index = value
    state.home.current_section = state.home.sections[state.home.section_index]
  }
}

export const prevHomeSection = (state, value) => {
  if( state.home.section_index > 0 ){
    setHomeSectionByIndex(state, state.home.section_index - 1)
  }
}

export const nextHomeSection = (state, value) => { 
  let tgIndex = ( state.home.section_index < (state.home.sections.length - 1) ) ? (state.home.section_index + 1) : 0
  setHomeSectionByIndex(state, tgIndex)
}
 